var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$mq.mobile)?_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav__title"},[_vm._t("navTitle")],2),_vm._v(" "),_c('div',{staticClass:"nav__list"},[_vm._t("navList")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d5ff25","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/SectionNav.vue
// module id = null
// module chunks = 